import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Checkbox from "@mui/material/Checkbox";
import Stack from "@mui/material/Stack";

import NavBar from "../../components/navBar/navBar";

const headerCellSx = {
  backgroundColor: (theme) => theme.palette.grey[100],
  fontWeight: "bold",
  textTransform: "uppercase",
  fontSize: "0.85rem",
  color: "#424242",
  whiteSpace: "nowrap",
};

const bodyCellSx = {
  whiteSpace: "nowrap",
};

const PatientArchive = () => {
  return (
    <>
      <NavBar active="" />
      <Box sx={{ maxWidth: "95%", mx: "auto", mt: 2 }}>
        <Box sx={{ display: "flex", gap: 2 }}>
          {/* Sidebar */}
          <Paper sx={{ width: 220, flexShrink: 0, p: 2 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
              Subject Menu
            </Typography>
            <List dense disablePadding>
              <ListItemButton component={Link} to="/patient">
                <ListItemText primary="Subjects" />
              </ListItemButton>
              <ListItemButton component={Link} to="/patient/archive/" selected>
                <ListItemText primary="Subjects Archived" />
              </ListItemButton>
            </List>
          </Paper>

          {/* Main Content */}
          <Paper sx={{ flex: 1 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ p: 2 }}>
              <Typography variant="h6">Subjects</Typography>
              <Button variant="contained" color="error" size="small">
                Unarchive
              </Button>
            </Stack>

            <TableContainer>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={headerCellSx} padding="checkbox">
                      <Checkbox size="small" />
                    </TableCell>
                    <TableCell sx={headerCellSx}>Email</TableCell>
                    <TableCell sx={headerCellSx}>Messages</TableCell>
                    <TableCell sx={headerCellSx}>First Name</TableCell>
                    <TableCell sx={headerCellSx}>Last Name</TableCell>
                    <TableCell sx={headerCellSx}>Birth Year</TableCell>
                    <TableCell sx={headerCellSx}>Practitioner</TableCell>
                    <TableCell sx={headerCellSx}>Clinic</TableCell>
                    <TableCell sx={headerCellSx}>Appointment</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.from({ length: 6 }).map((_, index) => (
                    <TableRow key={index} hover>
                      <TableCell padding="checkbox">
                        <Checkbox size="small" />
                      </TableCell>
                      <TableCell sx={bodyCellSx}>susanmackiesmith@gmail.com</TableCell>
                      <TableCell sx={bodyCellSx} />
                      <TableCell sx={bodyCellSx}>Susan</TableCell>
                      <TableCell sx={bodyCellSx}>Smith</TableCell>
                      <TableCell sx={bodyCellSx}>1990-07-28</TableCell>
                      <TableCell sx={bodyCellSx} />
                      <TableCell sx={bodyCellSx}>appiell.ai</TableCell>
                      <TableCell sx={bodyCellSx} />
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Box>
      </Box>
    </>
  );
};

export default PatientArchive;
